
import {Theme} from "@react-navigation/native";

const LOCAL_STORAGE_SCHEME = "colorScheme";

type NAME_TYPES =
// NECESSARY COLORS !!!!!!!!
    "primaryColor"
    | "highConBackground"
    | "lowConBackground"
    | "lowConText"
    | "highConText"
    | "mainBarGradiant"
    | "drawerGradiant"
    | "drawerIconGradiant"
    | "shadow"
    | "separator"
    | "transparentBackground"
    | "transparentPrimary"
    | "selectedBackgroundPrimary"
    | "transparentBackgroundHighlight"
    | "backlightPrimary"
    // END OF NECESSARY COLORS !!!!!!!!
    | "red" | "green" | "yellow";

type THEME_TYPES = "light" | "dark";

function hexToRgb(hex:string) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

class Colors {
    theme = "light";
    primary = "#4169E1";

    constructor(props: any) {
        this.theme = props.theme;
        this.primary = props.primary;
    }

    static instance(theme: any, primary: string) {
        return new Colors({theme: theme, primary: primary})
    }

    lightColorScheme = (key: NAME_TYPES)=>{
        const colors = {
            primaryColor: this.primary,
            highConBackground: "#fff",
            lowConBackground: "#f2f2f2",
            lowConText: "#4D4D4D",
            highConText: "#333",
            mainBarGradiant: ['#4169E1', '#003CAD'],
            drawerGradiant: ['#F9F9F9', '#EEEEEE'],
            drawerIconGradiant: ["#7D93FF", "#003CAD"],
            shadow: "#00000030",
            separator: "#CCCCCC",
            transparentBackground: "#25252590",
            transparentBackgroundHighlight: "#ffffffF0",
            transparentPrimary: `${this.primary}99`,
            selectedBackgroundPrimary: `${this.primary + "30"}`,
            backlightPrimary: `${this.primary}29`,
            red: "#EB5757",
            green: "#00C853",
            yellow: "#F2994A"
        }
        return colors[key];
    }

    darkColorScheme = (key: NAME_TYPES)=>{
        const colors = {
            primaryColor: this.primary,
            highConBackground: "#000",
            lowConBackground: "#252525",
            lowConText: "#eeeeee",
            highConText: "#fff",
            mainBarGradiant: ['#4169E1', '#003CAD'],
            drawerGradiant: ['#151515', '#151515'],
            drawerIconGradiant: ["#7D93FF", "#003CAD"],
            shadow: "#00000030",
            separator: "#1A1A1A",
            transparentBackground: "#f2f2f290",
            transparentBackgroundHighlight: "#000000F0",
            transparentPrimary: `${this.primary}99`,
            selectedBackgroundPrimary: "#25252590",
            backlightPrimary: `${this.primary}29`,
            red: "#EB5757",
            green: "#00C853",
            yellow: "#F2994A"
        }
        return colors[key];
    }

    get(key: NAME_TYPES): string | string[] {
        switch (this.theme) {
            case "dark":
                return this.darkColorScheme(key);
            case "light":
            default:
                return this.lightColorScheme(key);
        }
    }

    getColorByTheme(key: NAME_TYPES, theme: any) {
        switch (theme) {
            case "dark":
                return this.darkColorScheme(key);
            case "light":
            default:
                return this.lightColorScheme(key);
        }
    }

    getNavigatorDarkTheme() {
        return {
            dark: true,
            colors: {
                primary: this.primary,
                background: this.getColorByTheme("highConBackground", "dark") as string,
                card: this.getColorByTheme("lowConBackground", "dark") as string,
                text: this.getColorByTheme("highConText", "dark") as string,
                border: 'rgb(39, 39, 41)',
                notification: 'rgb(255, 69, 58)',
            },
        };
    }

    getNavigatorLightTheme() {
        return {
            dark: false,
            colors: {
                primary: this.primary,
                background: this.getColorByTheme("highConBackground", "light") as string,
                card: this.getColorByTheme("lowConBackground", "light") as string,
                text: this.getColorByTheme("highConText", "light") as string,
                border: 'rgb(216, 216, 216)',
                notification: 'rgb(255, 59, 48)',
            },
        };
    }
}

export {
    Colors
}